export function index ({offset = 0, limit = 999})
{
    return axios.get(route('api.manage.companies.companyValues'),
    	{ params: {offset, limit} })
        .then(response => response.data);
}

export function store (data)
{
    return axios.post(route('api.manage.companies.companyValues'), data)
        .then(response => response.data);
}

export function update (id, data)
{
    return axios.patch(route('api.manage.companyValues.update', { companyValueId: id }), data)
        .then(response => response.data);
}

export function destroy (id)
{
    return axios.delete(route('api.manage.companyValues.destroy', { companyValueId: id }));
}
